'use strict'

const Video = {
  playerContainers: $('.video__player:not(#video__modal,.video__modal,.video__player--native)'),
  players: []
}

// Used to publicy expose initialized players
window.videoPlayers = []

Video.init = function () {
  if (Video.playerContainers.length <= 0) {
    return
  }

  if (typeof Plyr === 'undefined') {
    return
  }

  Video.playerContainers.each(function (i, player) {
    Video.players.push(new Plyr(player))
  })

  window.videoPlayers = Video.players
}

export { Video }
